import React, { useState, useRef} from 'react';
import axios from 'axios';
import Notification from '../messagerie_user/notification';
import Navigation from '../navigation/navigationVisiteur';
import CloseButton from 'react-bootstrap/CloseButton';
import PostAffichage from './postAffichage';
import { Modal, Alert } from 'react-bootstrap';
import Dropdown from 'react-bootstrap/Dropdown';

function PostAjoutCoach(props) {
    const fileInputRef = useRef(null);
    const [fenetreOuverte, setFenetreOuverte] = useState(false);
    const [containerActive, setContainerActive] = useState(false);
    const [activ, setActive] = useState(true);
    const [activ2, setActive2] = useState(false);
    const [photo_, setPhoto_] = useState(false);
    const [url_photo, setUrl_photo] = useState('');
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [reponse, setResponse] = useState("");
    const [text, setText] = useState("");
    const [photo, setPhoto] = useState([]);
    const apiUrl = process.env.REACT_APP_API_URL;



    const handlePost = async (event) => {
        event.preventDefault();
        setIsLoading(true);
        let audience;
        if (activ === true && activ2 === false) {
            audience = "public";
        } else if (activ === false && activ2 === true) {
            audience = "equipe";
        }

        if (!text) {
            setError("Texte vide");
            setIsLoading(false);
            return;
        }

        const formData = new FormData();
        formData.append('text', text);
        formData.append('audience', audience);
        photo.forEach(file => {
            formData.append('photo', file);
        });
        formData.append('id_auteur', props.userData.user.donnée.results[0].id);
        formData.append('type', props.userData.user.type);

        try {
            const response = await axios.post(`${apiUrl}/post/ajout`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
                withCredentials: true
            });

            setResponse(response.data);
            setError(null);
            setIsLoading(false);
            setPhoto([]);
            setText("");
            setFenetreOuverte(false);
            setTimeout(() => {
                setResponse(null);
            }, 20000);
        } catch (error) {
            setIsLoading(false);
            setError(error.response.data.message);
        }
    };

    const handleButtonClick = () => {
        fileInputRef.current.click();
    };

    const handleFileChange = (event) => {
        const files = event.target.files;
        setPhoto((prevPhoto) => [...prevPhoto, ...files]);
    };

    const supp_img = () => {
        const supp = photo.filter(image => image.name !== url_photo[1]);
        setUrl_photo('');
        setPhoto_('');
        setPhoto(supp);
    };

    const handleCloseModal = () => {
        setFenetreOuverte(false);
        setIsLoading(false);
        setPhoto([]);
        setText("");
        setError(null);
        setContainerActive(false)
    };

    if (isLoading) {
        return (
            <div className="centered-content">
                <img src="/img/logo.png" alt="Logo" className="centered-logo" />
                <br />
                <span className="loader"></span>
            </div>
        );
    }

    return (
        <>
            {props.userData ? (
                <>
                    <div className="main post">
                        <Notification userData={props.userData} />
                        <div className='post1'>
                            <div className="publi2">
                                <div className="nom1">
                                    <img src={`${apiUrl}/image/equipe/${props.userData.user.donnée.results[0].logo}`} alt="logo de l'équipe" />
                                </div>
                                <div className="post-header">
                                    <h3>{props.userData.user.donnée.results[0].nom_coach} {props.userData.user.donnée.results[0].prenom}&nbsp; &nbsp;</h3>
                                    <p className="date">{props.userData.user.donnée.results[0].nom_equipe} {"("} {props.userData.user.donnée.results[0].categorie} {")"} &nbsp; &nbsp;</p>
                                </div>
                                <input placeholder='  Quoi de neuf ?' style={{ border: "1px solid #ced4da" }} readOnly onClick={() => { setFenetreOuverte(true); }}></input>
                            </div>
                        </div>
                        {reponse && (
                            <Alert variant="success">Félicitations ! Post ajouté avec succès.</Alert>
                        )}
                        <br />
                        <PostAffichage userData={props.userData} type={props.type} />
                        {fenetreOuverte && (
                            <Modal show={fenetreOuverte} onHide={handleCloseModal}>
                                <Modal.Header closeButton>
                                    <Modal.Title>Créer un nouveau post</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    {error && <Alert variant="danger">{error}</Alert>}
                                    {photo_ ? (
                                        <>
                                            <Dropdown align="end">
                                                <Dropdown.Toggle variant="secondary" id="dropdown-basic">
                                                    Options
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu>
                                                    <Dropdown.Item onClick={supp_img}>Supprimer l'image</Dropdown.Item>
                                                    <Dropdown.Item onClick={() => { setPhoto_(""); setUrl_photo("") }}>Revenir en arrière</Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown>
                                            <div className='image_ajout_post'><img style={{ maxWidth: '350px' }} src={url_photo[0]} alt='image_ajoutée' /></div>
                                        </>
                                    ) : (
                                        <div className="wrapper">
                                            {!containerActive ? (
                                                <section className="post">
                                                    <form>
                                                        <div className="content">
                                                            <img src={`${apiUrl}/image/equipe/${props.userData.user.donnée.results[0].logo}`} alt="logo" />
                                                            <div className="details">
                                                                <p>{props.userData.user.donnée.results[0].nom_coach} {props.userData.user.donnée.results[0].prenom}</p>
                                                                <div className="privacy" onClick={() => setContainerActive(true)}>
                                                                    <span src='/quitter.png'>{activ ? "Public" : "Equipe"}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <textarea placeholder="Quoi de neuf ?" required value={text} onChange={(e) => setText(e.target.value)}></textarea>
                                                        <div className="options">
                                                            <p onClick={handleButtonClick}>Ajouter des photos</p>
                                                            <input type="file" ref={fileInputRef} id="list" accept=".jpg" multiple style={{ display: 'none' }} onChange={handleFileChange} />
                                                            <ul className="list">
                                                                {photo && photo.slice(0, 6).map((file, index) => (
                                                                    <li key={index} onClick={() => { setPhoto_(true); setUrl_photo([URL.createObjectURL(file), file.name]) }}>
                                                                        <img src={URL.createObjectURL(file)} alt={`Photo_${index + 1}`} />
                                                                    </li>
                                                                ))}
                                                            </ul>
                                                        </div>
                                                        <button onClick={handlePost}>Publier</button>
                                                        <br />
                                                    </form>
                                                </section>
                                            ) : (
                                                <section className="audience">
                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <header>
                                                            <p>Audience</p>
                                                        </header>
                                                        <CloseButton onClick={() => { setContainerActive(false) }} />
                                                    </div>
                                                    <hr />
                                                    <div className="content">
                                                        <p>Qui peut voir votre publication ?</p>
                                                    </div>
                                                    <ul className="list">
                                                        <li onClick={() => { setActive(true); setActive2(false) }} className={`${activ ? ' active' : ''}`}>
                                                            <div className="column">
                                                                <div className="details">
                                                                    <p>Public</p>
                                                                    <span>Tous les utilisateurs de la plateforme FootProManager</span>
                                                                </div>
                                                            </div>
                                                            <div className="radio"></div>
                                                        </li>
                                                        <li onClick={() => { setActive(false); setActive2(true) }} className={`${activ2 ? ' active' : ''}`}>
                                                            <div className="column">
                                                                <div className="details">
                                                                    <p>Équipe</p>
                                                                    <span>Seuls les membres de votre équipe</span>
                                                                </div>
                                                            </div>
                                                            <div className="radio"></div>
                                                        </li>
                                                    </ul>
                                                </section>
                                            )}
                                        </div>
                                    )}
                                </Modal.Body>
                            </Modal>
                        )}
                    </div>
                </>
            ) : (
                <>
                    <Navigation />
                    <div id="alert-message" className="alert">
                        <strong>ERROR ! </strong>{error} <span id="alert-text"></span>
                    </div>
                </>
            )}
        </>
    );
}

export default PostAjoutCoach;
